import { type MetaFunction } from '@remix-run/node'
import { Container } from '#app/components/layout/container'
import { Flex } from '#app/components/layout/flex'
import { H1 } from '#app/components/typography/h1'
import { H2 } from '#app/components/typography/h2'
import { H3 } from '#app/components/typography/h3'
import { Hr } from '#app/components/typography/hr'
import { P } from '#app/components/typography/p'

export const meta: MetaFunction = () => {
	return [{ name: 'robots', content: `noindex,nofollow` }]
}

export default function DesignSystemTestPage() {
	return (
		<Container>
			<H1>Design System Test Page</H1>
			<H2>Fluid Space Scale</H2>
			<Flex orientation="vertical" gap="10">
				<div className="h-fluid-1 w-fluid-1 bg-emerald-500" />
				<div className="h-fluid-2 w-fluid-2 bg-emerald-500" />
				<div className="h-fluid-3 w-fluid-3 bg-emerald-500" />
				<div className="h-fluid-4 w-fluid-4 bg-emerald-500" />
				<div className="h-fluid-5 w-fluid-5 bg-emerald-500" />
				<div className="h-fluid-6 w-fluid-6 bg-emerald-500" />
				<div className="h-fluid-7 w-fluid-7 bg-emerald-500" />
				<div className="h-fluid-8 w-fluid-8 bg-emerald-500" />
				<div className="h-fluid-9 w-fluid-9 bg-emerald-500" />
				<div className="h-fluid-10 w-fluid-10 bg-emerald-500" />
				<div className="h-fluid-11 w-fluid-11 bg-emerald-500" />
				<div className="h-fluid-12 w-fluid-12 bg-emerald-500" />
				<div className="h-fluid-13 w-fluid-13 bg-emerald-500" />
				<div className="h-fluid-14 w-fluid-14 bg-emerald-500" />
				<div className="h-fluid-15 w-fluid-15 bg-emerald-500" />
				<div className="h-fluid-16 w-fluid-16 bg-emerald-500" />
				<div className="h-fluid-17 w-fluid-17 bg-emerald-500" />
				<div className="h-fluid-18 w-fluid-18 bg-emerald-500" />
				<div className="h-fluid-19 w-fluid-19 bg-emerald-500" />
				<div className="h-fluid-20 w-fluid-20 bg-emerald-500" />
			</Flex>
			<H3>Viewport Padding</H3>
			<div className="h-viewport-padding w-viewport-padding bg-emerald-500" />
			<H3>Minimum Tap Target</H3>
			<div className="h-tap w-tap bg-emerald-500" />
			<H2>Website width</H2>
			<div>
				<div className="w-website h-10 rotate-90 bg-gradient-to-r from-indigo-500 to-emerald-500" />
			</div>
			<H2>Font families</H2>
			<P>Inter</P>
			<pre>Fira Code VF</pre>
			<H2>Type Scale</H2>
			<p className="text-md">text-md</p>
			<H2>Fluid Type Scale</H2>
			<P className="text-fluid-xs">text-xs</P>
			<P className="text-fluid-sm">text-sm</P>
			<P className="text-fluid-md">text-md</P>
			<P className="text-fluid-lg">text-lg</P>
			<P className="text-fluid-xl">text-xl</P>
			<P className="text-fluid-2xl">text-2xl</P>
			<P className="text-fluid-3xl">text-3xl</P>
			<P className="text-fluid-4xl">text-4xl</P>
			<P className="text-fluid-5xl">text-5xl</P>
			<P className="text-fluid-6xl">text-6xl</P>
			<H2>Semantic Color Tokens</H2>
			<H3>Background and foreground</H3>
			<Flex gap="10" wrap>
				<Flex justify="center" items="center" className="bg-background h-48 w-48 border text-xs">
					*-background
				</Flex>
				<Flex justify="center" items="center" className="bg-foreground text-background h-48 w-48 text-xs">
					*-foreground
				</Flex>
			</Flex>
			<H3>Brand</H3>
			<Flex gap="10" wrap>
				<Flex justify="center" items="center" className="bg-brand-bg h-48 w-48 text-xs">
					*-brand-bg
				</Flex>
				<Flex justify="center" items="center" className="bg-brand-bg-hover h-48 w-48 text-xs">
					*-brand-bg-hover
				</Flex>
				<Flex justify="center" items="center" className="bg-brand-bg-active h-48 w-48 text-xs">
					*-brand-bg-active
				</Flex>
				<Flex justify="center" items="center" className="bg-brand-border h-48 w-48 text-xs">
					*-brand-border
				</Flex>
				<Flex justify="center" items="center" className="bg-brand-border-hover h-48 w-48 text-xs">
					*-brand-border-hover
				</Flex>
				<Flex justify="center" items="center" className="bg-brand-border-active h-48 w-48 text-xs">
					*-brand-border-active
				</Flex>
				<Flex justify="center" items="center" className="bg-brand-card-title text-background h-48 w-48 text-xs">
					*-brand-card-title
				</Flex>
				<Flex justify="center" items="center" className="bg-brand-text h-48 w-48 text-xs">
					*-brand-text
				</Flex>
				<Flex justify="center" items="center" className="bg-brand-text-hover h-48 w-48 text-xs">
					*-brand-text-hover
				</Flex>
				<Flex justify="center" items="center" className="bg-brand-text-active h-48 w-48 text-xs">
					*-brand-text-active
				</Flex>
			</Flex>
			<H3>Success</H3>
			<Flex gap="10" wrap>
				<Flex justify="center" items="center" className="bg-success-bg h-48 w-48 text-xs">
					*-success-bg
				</Flex>
				<Flex justify="center" items="center" className="bg-success-bg-hover h-48 w-48 text-xs">
					*-success-bg-hover
				</Flex>
				<Flex justify="center" items="center" className="bg-success-bg-active h-48 w-48 text-xs">
					*-success-bg-active
				</Flex>
				<Flex justify="center" items="center" className="bg-success-border h-48 w-48 text-xs">
					*-success-border
				</Flex>
				<Flex justify="center" items="center" className="bg-success-border-hover h-48 w-48 text-xs">
					*-success-border-hover
				</Flex>
				<Flex justify="center" items="center" className="bg-success-border-active h-48 w-48 text-xs">
					*-success-border-active
				</Flex>
				<Flex justify="center" items="center" className="bg-success-card-title text-background h-48 w-48 text-xs">
					*-success-card-title
				</Flex>
				<Flex justify="center" items="center" className="bg-success-text h-48 w-48 text-xs">
					*-success-text
				</Flex>
				<Flex justify="center" items="center" className="bg-success-text-hover h-48 w-48 text-xs">
					*-success-text-hover
				</Flex>
				<Flex justify="center" items="center" className="bg-success-text-active h-48 w-48 text-xs">
					*-success-text-active
				</Flex>
			</Flex>
			<H3>Info</H3>
			<Flex gap="10" wrap>
				<Flex justify="center" items="center" className="bg-info-bg h-48 w-48 text-xs">
					*-info-bg
				</Flex>
				<Flex justify="center" items="center" className="bg-info-bg-hover h-48 w-48 text-xs">
					*-info-bg-hover
				</Flex>
				<Flex justify="center" items="center" className="bg-info-bg-active h-48 w-48 text-xs">
					*-info-bg-active
				</Flex>
				<Flex justify="center" items="center" className="bg-info-border h-48 w-48 text-xs">
					*-info-border
				</Flex>
				<Flex justify="center" items="center" className="bg-info-border-hover h-48 w-48 text-xs">
					*-info-border-hover
				</Flex>
				<Flex justify="center" items="center" className="bg-info-border-active h-48 w-48 text-xs">
					*-info-border-active
				</Flex>
				<Flex justify="center" items="center" className="bg-info-card-title text-background h-48 w-48 text-xs">
					*-info-card-title
				</Flex>
				<Flex justify="center" items="center" className="bg-info-text h-48 w-48 text-xs">
					*-info-text
				</Flex>
				<Flex justify="center" items="center" className="bg-info-text-hover h-48 w-48 text-xs">
					*-info-text-hover
				</Flex>
				<Flex justify="center" items="center" className="bg-info-text-active h-48 w-48 text-xs">
					*-info-text-active
				</Flex>
			</Flex>
			<H3>Warning</H3>
			<Flex gap="10" wrap>
				<Flex justify="center" items="center" className="bg-warning-bg h-48 w-48 text-xs">
					*-warning-bg
				</Flex>
				<Flex justify="center" items="center" className="bg-warning-bg-hover h-48 w-48 text-xs">
					*-warning-bg-hover
				</Flex>
				<Flex justify="center" items="center" className="bg-warning-bg-active h-48 w-48 text-xs">
					*-warning-bg-active
				</Flex>
				<Flex justify="center" items="center" className="bg-warning-border h-48 w-48 text-xs">
					*-warning-border
				</Flex>
				<Flex justify="center" items="center" className="bg-warning-border-hover h-48 w-48 text-xs">
					*-warning-border-hover
				</Flex>
				<Flex justify="center" items="center" className="bg-warning-border-active h-48 w-48 text-xs">
					*-warning-border-active
				</Flex>
				<Flex justify="center" items="center" className="bg-warning-card-title text-background h-48 w-48 text-xs">
					*-warning-card-title
				</Flex>
				<Flex justify="center" items="center" className="bg-warning-text h-48 w-48 text-xs">
					*-warning-text
				</Flex>
				<Flex justify="center" items="center" className="bg-warning-text-hover h-48 w-48 text-xs">
					*-warning-text-hover
				</Flex>
				<Flex justify="center" items="center" className="bg-warning-text-active h-48 w-48 text-xs">
					*-warning-text-active
				</Flex>
			</Flex>
			<H3>Danger</H3>
			<Flex gap="10" wrap>
				<Flex justify="center" items="center" className="bg-danger-bg h-48 w-48 text-xs">
					*-danger-bg
				</Flex>
				<Flex justify="center" items="center" className="bg-danger-bg-hover h-48 w-48 text-xs">
					*-danger-bg-hover
				</Flex>
				<Flex justify="center" items="center" className="bg-danger-bg-active h-48 w-48 text-xs">
					*-danger-bg-active
				</Flex>
				<Flex justify="center" items="center" className="bg-danger-border h-48 w-48 text-xs">
					*-danger-border
				</Flex>
				<Flex justify="center" items="center" className="bg-danger-border-hover h-48 w-48 text-xs">
					*-danger-border-hover
				</Flex>
				<Flex justify="center" items="center" className="bg-danger-border-active h-48 w-48 text-xs">
					*-danger-border-active
				</Flex>
				<Flex justify="center" items="center" className="bg-danger-card-title text-background h-48 w-48 text-xs">
					*-danger-card-title
				</Flex>
				<Flex justify="center" items="center" className="bg-danger-text h-48 w-48 text-xs">
					*-danger-text
				</Flex>
				<Flex justify="center" items="center" className="bg-danger-text-hover h-48 w-48 text-xs">
					*-danger-text-hover
				</Flex>
				<Flex justify="center" items="center" className="bg-danger-text-active h-48 w-48 text-xs">
					*-danger-text-active
				</Flex>
			</Flex>
			<H3>Muted</H3>
			<Flex gap="10" wrap>
				<Flex justify="center" items="center" className="bg-muted-50 h-48 w-48 text-xs">
					*-muted-50
				</Flex>
				<Flex justify="center" items="center" className="bg-muted-100 h-48 w-48 text-xs">
					*-muted-100
				</Flex>
				<Flex justify="center" items="center" className="bg-muted-200 h-48 w-48 text-xs">
					*-muted-200
				</Flex>
				<Flex justify="center" items="center" className="bg-muted-300 h-48 w-48 text-xs">
					*-muted-300
				</Flex>
				<Flex justify="center" items="center" className="bg-muted-400 h-48 w-48 text-xs">
					*-muted-400
				</Flex>
				<Flex justify="center" items="center" className="bg-muted-500 h-48 w-48 text-xs">
					*-muted-500
				</Flex>
				<Flex justify="center" items="center" className="bg-muted-600 text-background h-48 w-48 text-xs">
					*-muted-600
				</Flex>
				<Flex justify="center" items="center" className="bg-muted-700 text-background h-48 w-48 text-xs">
					*-muted-700
				</Flex>
				<Flex justify="center" items="center" className="bg-muted-800 text-background h-48 w-48 text-xs">
					*-muted-800
				</Flex>
				<Flex justify="center" items="center" className="bg-muted-900 text-background h-48 w-48 text-xs">
					*-muted-900
				</Flex>
				<Flex justify="center" items="center" className="bg-muted-950 text-background h-48 w-48 text-xs">
					*-muted-950
				</Flex>
			</Flex>
			<H2>Animations</H2>
			<Flex gap="10" wrap>
				<Flex justify="center" items="center" className="bg-muted-100 h-48 w-48 animate-bounce text-xs">
					bounce
				</Flex>
				<Flex justify="center" items="center" className="bg-muted-100 animate-eclipse h-48 w-48 text-xs">
					eclipse
				</Flex>
			</Flex>
			<Hr />
			<H2>Dark Theme</H2>
			<div data-theme="dark" className="bg-background text-foreground rounded-xl p-8">
				<H2>Font families</H2>
				<P>Inter</P>
				<pre>Fira Code VF</pre>
				<H2>Semantic Color Tokens</H2>
				<H3>Background and foreground</H3>
				<Flex gap="10" wrap>
					<Flex justify="center" items="center" className="bg-background h-48 w-48 border text-xs">
						*-background
					</Flex>
					<Flex justify="center" items="center" className="bg-foreground text-background h-48 w-48 text-xs">
						*-foreground
					</Flex>
				</Flex>
				<H3>Brand</H3>
				<Flex gap="10" wrap>
					<Flex justify="center" items="center" className="bg-brand-bg h-48 w-48 text-xs">
						*-brand-bg
					</Flex>
					<Flex justify="center" items="center" className="bg-brand-bg-hover h-48 w-48 text-xs">
						*-brand-bg-hover
					</Flex>
					<Flex justify="center" items="center" className="bg-brand-bg-active h-48 w-48 text-xs">
						*-brand-bg-active
					</Flex>
					<Flex justify="center" items="center" className="bg-brand-border h-48 w-48 text-xs">
						*-brand-border
					</Flex>
					<Flex justify="center" items="center" className="bg-brand-border-hover h-48 w-48 text-xs">
						*-brand-border-hover
					</Flex>
					<Flex justify="center" items="center" className="bg-brand-border-active h-48 w-48 text-xs">
						*-brand-border-active
					</Flex>
					<Flex justify="center" items="center" className="bg-brand-card-title h-48 w-48 text-xs">
						*-brand-card-title
					</Flex>
					<Flex justify="center" items="center" className="bg-brand-text h-48 w-48 text-xs">
						*-brand-text
					</Flex>
					<Flex justify="center" items="center" className="bg-brand-text-hover h-48 w-48 text-xs">
						*-brand-text-hover
					</Flex>
					<Flex justify="center" items="center" className="bg-brand-text-active h-48 w-48 text-xs">
						*-brand-text-active
					</Flex>
				</Flex>
				<H3>Success</H3>
				<Flex gap="10" wrap>
					<Flex justify="center" items="center" className="bg-success-bg h-48 w-48 text-xs">
						*-success-bg
					</Flex>
					<Flex justify="center" items="center" className="bg-success-bg-hover h-48 w-48 text-xs">
						*-success-bg-hover
					</Flex>
					<Flex justify="center" items="center" className="bg-success-bg-active h-48 w-48 text-xs">
						*-success-bg-active
					</Flex>
					<Flex justify="center" items="center" className="bg-success-border h-48 w-48 text-xs">
						*-success-border
					</Flex>
					<Flex justify="center" items="center" className="bg-success-border-hover h-48 w-48 text-xs">
						*-success-border-hover
					</Flex>
					<Flex justify="center" items="center" className="bg-success-border-active h-48 w-48 text-xs">
						*-success-border-active
					</Flex>
					<Flex justify="center" items="center" className="bg-success-card-title h-48 w-48 text-xs">
						*-success-card-title
					</Flex>
					<Flex justify="center" items="center" className="bg-success-text h-48 w-48 text-xs">
						*-success-text
					</Flex>
					<Flex justify="center" items="center" className="bg-success-text-hover h-48 w-48 text-xs">
						*-success-text-hover
					</Flex>
					<Flex justify="center" items="center" className="bg-success-text-active h-48 w-48 text-xs">
						*-success-text-active
					</Flex>
				</Flex>
				<H3>Info</H3>
				<Flex gap="10" wrap>
					<Flex justify="center" items="center" className="bg-info-bg h-48 w-48 text-xs">
						*-info-bg
					</Flex>
					<Flex justify="center" items="center" className="bg-info-bg-hover h-48 w-48 text-xs">
						*-info-bg-hover
					</Flex>
					<Flex justify="center" items="center" className="bg-info-bg-active h-48 w-48 text-xs">
						*-info-bg-active
					</Flex>
					<Flex justify="center" items="center" className="bg-info-border h-48 w-48 text-xs">
						*-info-border
					</Flex>
					<Flex justify="center" items="center" className="bg-info-border-hover h-48 w-48 text-xs">
						*-info-border-hover
					</Flex>
					<Flex justify="center" items="center" className="bg-info-border-active h-48 w-48 text-xs">
						*-info-border-active
					</Flex>
					<Flex justify="center" items="center" className="bg-info-card-title h-48 w-48 text-xs">
						*-info-card-title
					</Flex>
					<Flex justify="center" items="center" className="bg-info-text h-48 w-48 text-xs">
						*-info-text
					</Flex>
					<Flex justify="center" items="center" className="bg-info-text-hover h-48 w-48 text-xs">
						*-info-text-hover
					</Flex>
					<Flex justify="center" items="center" className="bg-info-text-active h-48 w-48 text-xs">
						*-info-text-active
					</Flex>
				</Flex>
				<H3>Warning</H3>
				<Flex gap="10" wrap>
					<Flex justify="center" items="center" className="bg-warning-bg h-48 w-48 text-xs">
						*-warning-bg
					</Flex>
					<Flex justify="center" items="center" className="bg-warning-bg-hover h-48 w-48 text-xs">
						*-warning-bg-hover
					</Flex>
					<Flex justify="center" items="center" className="bg-warning-bg-active h-48 w-48 text-xs">
						*-warning-bg-active
					</Flex>
					<Flex justify="center" items="center" className="bg-warning-border h-48 w-48 text-xs">
						*-warning-border
					</Flex>
					<Flex justify="center" items="center" className="bg-warning-border-hover h-48 w-48 text-xs">
						*-warning-border-hover
					</Flex>
					<Flex justify="center" items="center" className="bg-warning-border-active h-48 w-48 text-xs">
						*-warning-border-active
					</Flex>
					<Flex justify="center" items="center" className="bg-warning-card-title h-48 w-48 text-xs">
						*-warning-card-title
					</Flex>
					<Flex justify="center" items="center" className="bg-warning-text h-48 w-48 text-xs">
						*-warning-text
					</Flex>
					<Flex justify="center" items="center" className="bg-warning-text-hover h-48 w-48 text-xs">
						*-warning-text-hover
					</Flex>
					<Flex justify="center" items="center" className="bg-warning-text-active h-48 w-48 text-xs">
						*-warning-text-active
					</Flex>
				</Flex>
				<H3>Danger</H3>
				<Flex gap="10" wrap>
					<Flex justify="center" items="center" className="bg-danger-bg h-48 w-48 text-xs">
						*-danger-bg
					</Flex>
					<Flex justify="center" items="center" className="bg-danger-bg-hover h-48 w-48 text-xs">
						*-danger-bg-hover
					</Flex>
					<Flex justify="center" items="center" className="bg-danger-bg-active h-48 w-48 text-xs">
						*-danger-bg-active
					</Flex>
					<Flex justify="center" items="center" className="bg-danger-border h-48 w-48 text-xs">
						*-danger-border
					</Flex>
					<Flex justify="center" items="center" className="bg-danger-border-hover h-48 w-48 text-xs">
						*-danger-border-hover
					</Flex>
					<Flex justify="center" items="center" className="bg-danger-border-active h-48 w-48 text-xs">
						*-danger-border-active
					</Flex>
					<Flex justify="center" items="center" className="bg-danger-card-title h-48 w-48 text-xs">
						*-danger-card-title
					</Flex>
					<Flex justify="center" items="center" className="bg-danger-text h-48 w-48 text-xs">
						*-danger-text
					</Flex>
					<Flex justify="center" items="center" className="bg-danger-text-hover h-48 w-48 text-xs">
						*-danger-text-hover
					</Flex>
					<Flex justify="center" items="center" className="bg-danger-text-active h-48 w-48 text-xs">
						*-danger-text-active
					</Flex>
				</Flex>
				<H3>Muted</H3>
				<Flex gap="10" wrap>
					<Flex justify="center" items="center" className="bg-muted-50 h-48 w-48 text-xs">
						*-muted-50
					</Flex>
					<Flex justify="center" items="center" className="bg-muted-100 h-48 w-48 text-xs">
						*-muted-100
					</Flex>
					<Flex justify="center" items="center" className="bg-muted-200 h-48 w-48 text-xs">
						*-muted-200
					</Flex>
					<Flex justify="center" items="center" className="bg-muted-300 h-48 w-48 text-xs">
						*-muted-300
					</Flex>
					<Flex justify="center" items="center" className="bg-muted-400 h-48 w-48 text-xs">
						*-muted-400
					</Flex>
					<Flex justify="center" items="center" className="bg-muted-500 h-48 w-48 text-xs">
						*-muted-500
					</Flex>
					<Flex justify="center" items="center" className="bg-muted-600 text-background h-48 w-48 text-xs">
						*-muted-600
					</Flex>
					<Flex justify="center" items="center" className="bg-muted-700 text-background h-48 w-48 text-xs">
						*-muted-700
					</Flex>
					<Flex justify="center" items="center" className="bg-muted-800 text-background h-48 w-48 text-xs">
						*-muted-800
					</Flex>
					<Flex justify="center" items="center" className="bg-muted-900 text-background h-48 w-48 text-xs">
						*-muted-900
					</Flex>
					<Flex justify="center" items="center" className="bg-muted-950 text-background h-48 w-48 text-xs">
						*-muted-950
					</Flex>
				</Flex>
			</div>
		</Container>
	)
}
